import { useCallback, useRef } from "react";

import { ScrollAreaContext } from "./ScrollAreaContext";

import type { FC, PropsWithChildren, TouchEvent } from "react";

interface ScrollAreaProps {
	className: string;
	touchMoveEnabled: boolean;
}

export const ScrollArea: FC<PropsWithChildren<ScrollAreaProps>> = ({ className, touchMoveEnabled, children }) => {
	const scrollDivRef = useRef<HTMLDivElement>(null);

	const onTouchMove = (e: TouchEvent<HTMLDivElement>) => {
		if (touchMoveEnabled) {
			return true;
		}
		e.preventDefault();
		return undefined;
	};

	const touchAction = touchMoveEnabled ? "auto" : "none";

	const scrollToTop = useCallback(() => {
		scrollDivRef.current?.scrollTo({ top: 0 });
	}, []);

	return (
		<ScrollAreaContext
			value={{
				scrollToTop,
			}}
		>
			<div
				ref={scrollDivRef}
				data-scroll="true"
				className={className}
				style={{ touchAction }}
				onTouchMove={onTouchMove}
			>
				{children}
			</div>
		</ScrollAreaContext>
	);
};
